// A ticket's type, for the screens. The vocabulary is repeated here rather than imported
// from src/services/tickets.js (TICKET_TYPES) because `web/` builds on its own and does
// not reach into the server tree. This is a THIRD copy, after TICKET_TYPES there and
// TYPE_VALUES in src/views/registry.js; test/web/ticket-type-ui.test.js compares
// TYPE_LABELS' keys with TICKET_TYPES, and test/views/ticket-type-field.test.js binds
// TICKET_TYPES to TYPE_VALUES, so none of the three can drift unnoticed. There is deliberately no "incident": the CRM folds it into `problem`.

export const TYPE_LABELS = Object.freeze({
  question: 'Question',
  problem: 'Problem',
  task: 'Task',
});

/**
 * QUESTION FIRST, not alphabetical: it is the commonest type on the desk by a wide
 * margin among the ones an agent picks by hand, and the first option is the one a hurried
 * agent takes.
 */
export function typeOptions() {
  return Object.keys(TYPE_LABELS).map((value) => ({ value, label: TYPE_LABELS[value] }));
}

/**
 * The options for a select whose current value may be one we do not know. Without the
 * extra option the browser shows the first entry for a value that matches none, so an
 * odd row would read as a different type and the next save would look like a change.
 */
export function typeOptionsFor(current) {
  const options = typeOptions();
  if (current && !TYPE_LABELS[current]) options.push({ value: current, label: current });
  return options;
}

/** A value shown verbatim when it is not one of ours, so an odd row is visible. */
export function typeLabel(value) {
  if (!value) return 'Not categorised';
  return TYPE_LABELS[value] ?? value;
}
